/* eslint-disable @typescript-eslint/naming-convention */
export enum FieldRequestFieldEnum {
  requested_amount = "requested_amount",
  repayment_time = "repayment_time",
  self_estimated_historic_revenue = "self_estimated_historic_revenue",
  self_estimated_revenue = "self_estimated_revenue",
  guarantors = "guarantors",
  accounting_data = "accounting_data",
  banking_data = "banking_data",
  property = "property",
  property_owner = "property_owner",
  unpaid_invoices = "unpaid_invoices",
  company_mortgage = "company_mortgage",
  additional_securities = "additional_securities",
  budget = "budget",
  business_plan = "business_plan",
  corona = "corona",
  suggested_amount = "suggested_amount",
  pawned_invoices = "pawned_invoices",
  parent_company_guarantee = "parent_company_guarantee",
  share_mortgage = "share_mortgage",
  refinancing = "refinancing",
  property_cash_flow = "property_cash_flow",
  construction_completed_repayment = "construction_completed_repayment",
  construction_estimate = "construction_estimate",
  building_permit = "building_permit",
  grouped_real_estate_collateral = "grouped_real_estate_collateral",
  grouped_real_estate_repayment = "grouped_real_estate_repayment",
  refinancing_amounts = "refinancing_amounts",
  leasing = "leasing",
}

export interface IFieldRequest<T = unknown> {
  id: string;
  type: string;
  displayName: string;
  field: FieldRequestFieldEnum;
  isSubmitted: boolean;
  isCollectedByLender: boolean;
  lenderComment: string | null;
  subtitle?: string;
  description?: string;
  submittedData: T;
}
